module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-Md.72577ac.woff2";